import { useEffect, useRef } from "react";

export const useValueWhileMounted = <T>(value: T) => {
  const valueRef = useRef<T | undefined>(value);
  useEffect(() => {
    valueRef.current = value;
    return () => {
      valueRef.current = undefined;
    };
  }, [value]);
  return valueRef;
};
